document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll(".kpi-number");

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseFloat(el.dataset.target);
          let count = 0;
          const increment = target / 60; // duration ~1s
          const counterInterval = setInterval(() => {
            count += increment;
            if (count >= target) {
              el.textContent = Math.round(target) + "%";
              clearInterval(counterInterval);
            } else {
              el.textContent = Math.round(count) + "%";
            }
          }, 16);
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.3 }
  );

  counters.forEach(counter => observer.observe(counter));
});
